import React from "react";
import { CHALLENGE } from "../../../../common/challengeConstants";
import { SlickCarousel } from "../../../../common";
import TeamBeginMemberCard from "../teamBeginMemberCard/TeamBeginMemberCard";
import './TeamBeginMemberCarousel.scss';

const TeamBeginMemberCarousel = ({
    teamSize,
    teamFullSize,
    badgeClassname,
    teamData,
    scoreTarget,
    challengeUserData
}) => {
    const getUserProfileUrl = (partyId) => {
        const userProfileInfo = challengeUserData.find(data => data?.partyId === partyId);
        return userProfileInfo?.pictureUrl;
    }

    const emptySlotCount = Math.max((teamFullSize || 0) - (teamSize || 0), 0);
    return (
        <div className="card-begin-outer">
            <div className="card-begin-title-wrapper">
                <div className="card-begin-title">
                    {CHALLENGE.beginTeamDashboard?.teamInfoHeading}
                </div>
            </div>
            <SlickCarousel
                slidesToShow={1}
                slidesToScroll={1}
            >
                {teamData?.map((user) => (
                    <div key={user.partyId}>
                        <TeamBeginMemberCard
                            userName={user.userName}
                            userId={user.aboId}
                            pictureUrl={getUserProfileUrl(user?.partyId) || '/images/challenge/default_challenge_profile.svg'}
                            isLeader={user.isLeader}
                            isNewMember={user.isNewMember}
                            isNewAbo={user.isNewAbo}
                            healthspanScore={user.registerUserData?.healthspan_score}
                            scoreEarned={user.userTotalChecklistScore}
                            scoreTarget={user.passScore}
                            remainingScore={Math.max(0, user.passScore - user.userTotalChecklistScore)}
                        />
                    </div>
                ))}
                {Array.from({ length: emptySlotCount }).map((_, index) => (
                    <div key={`empty-slot-${index}`}>
                        <TeamBeginMemberCard scoreTarget={scoreTarget} />
                    </div>
                ))}
            </SlickCarousel>
        </div>
    )
}

export default TeamBeginMemberCarousel;